import Vue from "vue";

async function getToken(request, http, cb) {
  if (Vue.prototype.$msal.isAuthenticated()) {
    let token = await Vue.prototype.$msal.acquireToken(request);
    if (!token) {
      cb(new Error("Failed to acquire token"));
      return;
    }
    http.defaults.headers["Authorization"] = `Bearer ${token.accessToken}`;
    cb(null, token.accessToken);
  } else {
    cb(new Error("User is no longer authenticated. Please login again."));
    return;
  }
}

export class AxiosAuthHttp {
  static createNewClient(options) {
    if (options == null) {
      throw new Error("Provided options for auth-http are null!");
    }
    if (options.axios == null) {
      throw new Error(
        "options.axios is required to generate a new http client"
      );
    }

    if (options.scopes == null) {
      throw new Error("options.scopes is required to retrieve token");
    }

    let axios = options.axios;
    let http = axios.create({
      baseURL: options.baseUrl,
      headers: {
        Authorization: null
      }
    });
    let scopes = options.scopes;

    http.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response.status === 401) {
          return new Promise((resolve, reject) =>
            getToken({ scopes: scopes }, http, () => {
              let config = error.response.config;
              config.headers.Authorization =
                http.defaults.headers["Authorization"];
              http({
                method: config.method,
                url: config.url,
                data: config.data,
                headers: {
                  Accept: config.headers["Accept"],
                  Authorization: config.headers["Authorization"],
                  "Content-Type": config.headers["Content-Type"]
                }
              }).then(
                res => resolve(res),
                err => reject(err)
              );
            })
          );
        } else {
          return Promise.reject(error);
        }
      }
    );

    if (options.router == null) {
      return http;
    }

    // Set up the router hooks for this resource
    options.router.beforeEach((to, from, next) => {
      getToken({ scopes: scopes }, http, (err, token) => {
        if (err) {
          if (options.onTokenFailure instanceof Function) {
            options.onTokenFailure(err);
          }
          next();
          return;
        }
        if (options.onTokenSuccess instanceof Function) {
          options.onTokenSuccess(http, token);
        }
        next();
      });
    });
    return http;
  }
}
